// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC0BVPFXJPyl4lh3Zb8UuZ39DsmpxNpJ_U',
    authDomain: 'ng-golf-project.firebaseapp.com',
    databaseURL: 'https://ng-golf-project.firebaseio.com',
    projectId: 'ng-golf-project',
    storageBucket: 'ng-golf-project.appspot.com',
    messagingSenderId: '285891733375',
    appId: '1:285891733375:web:f9786686bca05f035fdc4a'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
